<div class="dialog-container">
  <h2 mat-dialog-title>Record Insurance Loan Payment</h2>
  <div mat-dialog-content>
    <p class="dialog-message">
      Enter the loan payment details for the selected insurance policy
    </p>
    
    <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
      <!-- Hidden insurance_id field -->
      <input type="hidden" formControlName="insurance_id">
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select Loan</mat-label>
        <mat-select formControlName="loan_id" required>
          @for (loan of data.insurance.insurance_loans_collection; track loan.id) {
            <mat-option [value]="loan.id">{{ loan.name || 'Loan ' + loan.id }} - {{ loan.current_balance | currency:'USD':true:'1.2-2' }}</mat-option>
          }
        </mat-select>
        @if(paymentForm.get('loan_id')?.hasError('required')) {
          <mat-error>
            Loan selection is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Payment Date</mat-label>
        <input 
          matInput 
          [matDatepicker]="picker" 
          formControlName="date"
          required>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if(paymentForm.get('date')?.hasError('required')) {
          <mat-error>
            Date is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Payment Amount</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="amount" 
          required numberFormat>
        <span matPrefix>&nbsp;$&nbsp;</span>
        @if(paymentForm.get('amount')?.hasError('required')) {
          <mat-error>
            Amount is required
          </mat-error>
        }
        @if(paymentForm.get('amount')?.hasError('min')) {
          <mat-error>
            Amount must be greater than $0.01
          </mat-error>
        }
      </mat-form-field>

      <div class="checkbox-container">
        <mat-checkbox formControlName="payFromBank" class="pay-from-bank-checkbox">
          Pay from bank
        </mat-checkbox>
        <div class="checkbox-help-text">
          Check this to automatically create a transaction that subtracts these funds from the selected bank (requires selecting a bank)
        </div>
      </div>

      @if(paymentForm.get('payFromBank')?.value) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Bank Account</mat-label>
          <mat-select formControlName="bank_id">
            @for (bank of banks(); track bank.id) {
              <mat-option [value]="bank.id">{{ bank.name }}</mat-option>
            }
          </mat-select>
          @if(paymentForm.get('bank_id')?.hasError('required') && paymentForm.get('bank_id')?.touched) {
            <mat-error>
              Bank account is required when "Pay from bank" is checked
            </mat-error>
          }
        </mat-form-field>
      }
    </form>
  </div>
  
  <div mat-dialog-actions align="end">
    <button 
      mat-button 
      type="button" 
      [disabled]="loading" 
      (click)="onCancel()">
      Cancel
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      type="submit" 
      [disabled]="paymentForm.invalid || loading" 
      (click)="onSubmit()">
      @if(loading) {
        <span>Processing...</span>
      } @else {
        <span>Record Payment</span>
      }
    </button>
  </div>
</div>
